import { Typography } from '@freighthub/silhouette-core'
import { ShipmentMode } from 'features/ShipmentDetails'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { msToDays } from '../../formatDate'
import { IQuoteSheet, isImportToEU } from '../QuoteSheetModel'
import { IQuoteOption } from '../QuoteSheetOption'
import { useTypographyMigration } from '../useTypographyMigration'
import { QuoteOptionHelpIcon } from './QuoteOptionHelpIcon'

const modeToAdditionalTransitTime: Partial<Record<ShipmentMode, { time: string; hint: string }>> = {}

interface IQuoteOptionDurationProps {
  option: IQuoteOption
  routeQuoteType?: keyof IQuoteOption['routeQuotes']
  sheet: IQuoteSheet
  approximate?: boolean
}

export const QuoteOptionDuration: FC<IQuoteOptionDurationProps> = (props) => {
  const { option, routeQuoteType, sheet, approximate = false } = props
  const { translate } = useI18n()
  // @ts-expect-error TS(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  const durationInDays = durationInDaysOf(option, routeQuoteType)
  const extraWaitingTime = extraWaitTimeOf(sheet, option, routeQuoteType)
  const shouldUseTypographyForText = useTypographyMigration()
  const Component = shouldUseTypographyForText ? Typography : 'span'
  return (
    <Component data-userlane-id="qs-option-duration-details">
      {approximate && '~'}
      {`${durationInDays} `}
      {extraWaitingTime ? (
        <>
          (+ {extraWaitingTime.time}
          <QuoteOptionHelpIcon tooltip={translate(extraWaitingTime.hint)} />
          {') '}
        </>
      ) : null}
      {translate('day', { count: durationInDays })}
    </Component>
  )
}

function durationInDaysOf(option: IQuoteOption, routeQuoteType: string) {
  const duration = routeQuoteType ? option.routeQuotes[routeQuoteType].route.duration : option.totalDuration
  const durationInDays = msToDays(duration)
  return durationInDays
}

function extraWaitTimeOf(sheet: IQuoteSheet, option: IQuoteOption, routeQuoteType?: keyof IQuoteOption['routeQuotes']) {
  const { type, mode, routeQuotes } = option
  const shouldShowExtraWaitingTime =
    routeQuotes.postQuote &&
    isImportToEU(sheet) &&
    (!routeQuoteType || routeQuoteType === 'postQuote') &&
    type === 'lcl'
  const extraWaitingTime = shouldShowExtraWaitingTime && modeToAdditionalTransitTime[mode]
  return extraWaitingTime
}
